// PostHog Helper - sicheres Tracking mit Anomalie-Erkennung
function trackBoxEvent(eventName, properties = {}) {
  if (typeof posthog !== 'undefined') {
    posthog.capture(eventName, {
      ...properties,
      timestamp: new Date().toISOString(),
      page_url: window.location.href
    });
  }
}

class BuildABoxController {
  constructor(maxItems = 6, boxHandle) {
    this.maxItems = maxItems;
    this.boxHandle = boxHandle;
    this.isProcessing = false; // Prevent race conditions from rapid clicks
    this.tabId = Date.now() + '-' + Math.random().toString(36).substr(2, 9); // Unique ID for cross-tab lock

    this.boxMeals = {};
    this.boxId = null;
    this.boxPrice = null;
    this.boxData = null;

    this.headerPriceEl = $('.build-a-box-sidebar__header-price');
    this.missingItemsEl = $('.build-a-box-sidebar__missing-products-message');
    this.missingItemsMobileEl = $('.mobile-actions__missing-items');
    this.addToCartEl = $('#add-to-cart');
    this.addToCartMobileEl = $('#add-to-cart-mobile');
    this.emptyCartMessageEl = $('.build-a-box-sidebar__empty-cart');
    this.boxMealsContainerEl = $('.build-a-box-sidebar__cart-with-items');
    this.loaderEl = $('.build-a-box-sidebar__loader-container');

    // Mobile progress bar elements
    this.mobileProgressRowEl = $('.mobile-actions__progress-row');
    this.mobileCartRowEl = $('.mobile-actions__cart-row');
    this.mobileProgressFillEl = $('.mobile-progress-bar__fill');
    this.mobileProgressCountEl = $('.mobile-progress-bar__count');
  }

  async init() {
    try {
      await new Promise(resolve => setTimeout(resolve, 300));

      // Validate and parse localStorage data safely
      let boxMeals = {};
      try {
        const storedData = localStorage.getItem(`${this.boxHandle}-meals`);
        if (storedData) {
          const parsed = JSON.parse(storedData);
          if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
            // Validate each meal entry has required fields
            for (const [key, meal] of Object.entries(parsed)) {
              if (meal && typeof meal.quantity === 'number' && meal.quantity > 0 && meal.mealId) {
                boxMeals[key] = meal;
              }
            }
          }
        }
      } catch (e) {
        console.error('localStorage parse error:', e);
        localStorage.removeItem(`${this.boxHandle}-meals`);
      }

      const totalMeals = Object.values(boxMeals).reduce((acc, item) => acc + (item.quantity || 0), 0);

      if (this.boxHandle === '6er-meal-box' && totalMeals > 6) {
        localStorage.removeItem('6er-meal-box-meals');
        window.location.href = '/collections/12er-box';
        return;
      }

      if (this.boxHandle === '12er-meal-box' && totalMeals > 12) {
        localStorage.removeItem('12er-meal-box-meals');
        window.location.href = '/collections/18er-box';
        return;
      }

      // 18er is the largest box - reset if corrupted data exceeds limit
      if (this.boxHandle === '18er-meal-box' && totalMeals > 18) {
        localStorage.removeItem('18er-meal-box-meals');
        boxMeals = {};
      }

      this.boxData = await this._fetchBoxData(this.boxHandle);
      const { price, variants } = this.boxData;

      if (boxMeals && Object.keys(boxMeals).length > 0) {
        this.boxMeals = boxMeals;

        Object.keys(boxMeals).forEach(key => {
          this._appendMealItem(boxMeals[key]);
          this._updateMealListItemCount(key, boxMeals[key].quantity);
        });

        if (this.boxItemMealCount > 6) {
          $('.meal-card.meal_maxqty_6').addClass('disabled');
        }
        if (this.boxItemMealCount > 12) {
          $('.meal-card.meal_maxqty_12').addClass('disabled');
        }

        this._updateAddButtonStates();
        this._hideEmptyCartMessage();
      }

      this.boxId = variants[0].id;
      this._setBoxPrice(price);

      // Synchronisiere Button- und Row-Sichtbarkeit basierend auf aktuellem Meal-Count
      if (this.boxItemMealCount === this.maxItems) {
        this._showAddToCartButton();
        this._hideMissingItemsMessage();
      } else {
        this._hideAddToCartButton();
        this._showMissingItemsMessage();
      }

      this._updateMissingItemsCount();
      this._hideLoader();

      // Track page view with current state
      trackBoxEvent('box_page_viewed', {
        box_type: this.boxHandle,
        max_items: this.maxItems,
        loaded_meals_count: this.boxItemMealCount,
        has_previous_selection: Object.keys(this.boxMeals).length > 0,
        unique_meals_loaded: Object.keys(this.boxMeals).length
      });

      const that = this;

      $(document).on('click', '.meal-list-item__increase-quantity-button', function () {
        const mealData = $(this).data();
        that.addMealToBox(mealData);
      });

      $(document).on('click', '.meal-list-item__reduce-quantity-button', function () {
        const mealData = $(this).data();
        that.removeMealFromBox(mealData);
      });

      $(document).on('click', '#add-to-cart, #add-to-cart-mobile', function () {
        that.addToCart();
      });

    } catch (error) {
      console.error('Initialization error:', error);
    }
  }

  async addToCart() {
    // Prevent double-clicks / race conditions
    if (this.isProcessing) return;
    this.isProcessing = true;

    // Disable buttons immediately to prevent multiple clicks
    this.addToCartEl.prop('disabled', true).text('Wird hinzugefügt...');
    this.addToCartMobileEl.prop('disabled', true).text('Wird hinzugefügt...');

    // === CROSS-TAB LOCK ===
    const lockAcquired = this._acquireCartLock();
    if (!lockAcquired) {
      trackBoxEvent('box_cross_tab_lock_failed', { box_type: this.boxHandle, tab_id: this.tabId });
      alert('Eine Box wird gerade hinzugefügt. Bitte warte einen Moment.');
      this.addToCartEl.prop('disabled', false).text('In den Warenkorb');
      this.addToCartMobileEl.prop('disabled', false).text('In den Warenkorb');
      this.isProcessing = false;
      return;
    }

    try {
      // === ROBUSTE VALIDIERUNG ===
      // 1. Prüfe Meal-Count
      const mealCount = this.boxItemMealCount;
      const countValid = mealCount === this.maxItems;

      // 2. Prüfe dass boxMeals tatsächlich Einträge hat
      const mealsExist = Object.keys(this.boxMeals).length > 0;

      // 3. Prüfe dass jedes Meal gültige Daten hat
      const allMealsValid = Object.values(this.boxMeals).every(meal =>
        meal &&
        meal.mealId &&
        typeof meal.quantity === 'number' &&
        meal.quantity > 0
      );

      // 4. Prüfe dass boxId existiert
      const boxIdValid = this.boxId && this.boxId > 0;

      // 5. Berechne Summe der Quantities zur doppelten Sicherheit
      const totalQuantity = Object.values(this.boxMeals).reduce((sum, meal) => sum + (meal.quantity || 0), 0);
      const quantitySumValid = totalQuantity === this.maxItems;

      const validationPassed = countValid && mealsExist && allMealsValid && boxIdValid && quantitySumValid;

      const mealBreakdown = Object.values(this.boxMeals).map(m => ({
        id: m.mealId,
        title: m.title,
        qty: m.quantity
      }));

      // Track add to cart attempt
      trackBoxEvent('box_add_to_cart', {
        box_type: this.boxHandle,
        max_items: this.maxItems,
        total_meals: mealCount,
        box_id: this.boxId,
        validation_passed: validationPassed,
        validation_details: {
          count_valid: countValid,
          meals_exist: mealsExist,
          all_meals_valid: allMealsValid,
          box_id_valid: boxIdValid,
          quantity_sum_valid: quantitySumValid,
          total_quantity: totalQuantity
        },
        unique_meals: Object.keys(this.boxMeals).length,
        meal_breakdown: mealBreakdown
      });

      if (!validationPassed) {
        // Track anomaly when checkout attempted with invalid state
        trackBoxEvent('box_validation_failed', {
          box_type: this.boxHandle,
          max_items: this.maxItems,
          actual_count: mealCount,
          validation_details: {
            count_valid: countValid,
            meals_exist: mealsExist,
            all_meals_valid: allMealsValid,
            box_id_valid: boxIdValid,
            quantity_sum_valid: quantitySumValid,
            total_quantity: totalQuantity
          },
          meal_breakdown: mealBreakdown
        });

        // Detaillierte Fehlermeldung
        let errorMessage = `Bitte wählen Sie genau ${this.maxItems} Produkte aus.`;
        if (!mealsExist) {
          errorMessage = 'Bitte wählen Sie mindestens ein Produkt aus.';
        } else if (!countValid || !quantitySumValid) {
          errorMessage = `Bitte wählen Sie genau ${this.maxItems} Produkte aus. Aktuelle Anzahl: ${mealCount}.`;
        } else if (!allMealsValid) {
          errorMessage = 'Es gab ein Problem mit Ihrer Auswahl. Bitte laden Sie die Seite neu.';
        } else if (!boxIdValid) {
          errorMessage = 'Es gab ein technisches Problem. Bitte laden Sie die Seite neu.';
        }

        alert(errorMessage);
        this.addToCartEl.prop('disabled', false).text('In den Warenkorb');
        this.addToCartMobileEl.prop('disabled', false).text('In den Warenkorb');
        this.isProcessing = false;
        return;
      }

      const mealItems = Object.keys(this.boxMeals).map(key => ({ ...this.boxMeals[key] }));

      // === LINE ITEM PROPERTIES für Traceability ===
      const boxInstanceId = Date.now() + '-' + Math.random().toString(36).substr(2, 9);

      const box = {
        id: this.boxId,
        quantity: 1,
        properties: {
          _box_instance_id: boxInstanceId,
          _expected_meal_count: String(this.maxItems)
        }
      };

      const itemsToAdd = Object.keys(this.boxMeals).map(mealKey => {
        const { mealId, quantity } = this.boxMeals[mealKey];
        return {
          id: mealId,
          quantity,
          properties: {
            _box_instance_id: boxInstanceId,
            _box_handle: this.boxHandle,
            _box_size: String(this.maxItems)
          }
        };
      });

      // Finale Sicherheitsprüfung vor dem API-Call
      if (itemsToAdd.length === 0) {
        console.error('SECURITY: Attempted to add box without meals');
        trackBoxEvent('box_security_block', {
          box_type: this.boxHandle,
          reason: 'empty_items_to_add',
          box_id: this.boxId
        });
        alert('Es gab ein Problem. Bitte laden Sie die Seite neu und versuchen Sie es erneut.');
        this.addToCartEl.prop('disabled', false).text('In den Warenkorb');
        this.addToCartMobileEl.prop('disabled', false).text('In den Warenkorb');
        this.isProcessing = false;
        return;
      }

      console.log('[DEBUG addToCart] Sending to /cart/add.js:', JSON.stringify({ items: [box, ...itemsToAdd] }, null, 2));

      const itemsAddedToShopifyCart = await this._addItemsToShopifyCart({
        items: [box, ...itemsToAdd]
      });

      console.log('[DEBUG addToCart] Response from /cart/add.js:', JSON.stringify(itemsAddedToShopifyCart, null, 2));

      // Match per _box_instance_id UND variant id (Meals haben auch _box_instance_id)
      const boxItem = itemsAddedToShopifyCart.find(item =>
        item.id === box.id && item.properties && item.properties._box_instance_id === boxInstanceId
      );

      console.log('[DEBUG addToCart] Found boxItem in response: id=' + boxItem?.id + ', key="' + boxItem?.key + '", instanceId="' + boxItem?.properties?._box_instance_id + '"');

      const boxToStore = {
        ...box,
        boxInstanceId: boxInstanceId,
        boxItems: mealItems,
        key: boxItem.key,
        image: boxItem.image,
        quantity: boxItem.quantity,
        title: boxItem.title,
        handle: boxItem.handle
      };

      console.log('[DEBUG addToCart] Storing in localStorage:', JSON.stringify({ id: boxToStore.id, key: boxToStore.key, handle: boxToStore.handle, boxItemsCount: boxToStore.boxItems?.length }));

      // WICHTIG: Erst localStorage speichern, DANN verifizieren
      // (sonst findet _correctCartOverflow keine erwarteten Meals und löscht alles)
      this.addBoxToLocalStorage(boxToStore);

      // === POST-ADD CART VERIFICATION ===
      await this._verifyCartAfterAdd();

      const keysToRemove = ['6er', '12er', '18er'];
      keysToRemove.forEach(size => {
        localStorage.removeItem(`${size}-meal-box-meals`);
      });

      window.cartDrawer.updateCart();
      this.clearSidecart();
      $('.meal-card.meal_maxqty_6').removeClass('disabled');
      $('.meal-card.meal_maxqty_12').removeClass('disabled');

      this.addToCartEl.prop('disabled', false).text('In den Warenkorb');
      this.addToCartMobileEl.prop('disabled', false).text('In den Warenkorb');
      this.isProcessing = false;

      // Track successful add to cart
      trackBoxEvent('box_add_to_cart_success', {
        box_type: this.boxHandle,
        max_items: this.maxItems,
        total_meals: mealItems.length,
        items_added_to_shopify: itemsAddedToShopifyCart.length,
        box_item_key: boxItem.key,
        box_instance_id: boxInstanceId
      });

      window.cartDrawer.openCart();
    } catch (error) {
      console.error('Error adding to cart:', error);

      // Track add to cart error
      trackBoxEvent('box_add_to_cart_error', {
        box_type: this.boxHandle,
        max_items: this.maxItems,
        total_meals: this.boxItemMealCount,
        error_message: error.message || 'Unknown error',
        error_status: error.status || null
      });

      this.addToCartEl.prop('disabled', false).text('In den Warenkorb');
      this.addToCartMobileEl.prop('disabled', false).text('In den Warenkorb');
      this.isProcessing = false;
    } finally {
      this._releaseCartLock();
    }
  }

  addMealToBox(mealData) {
    // Prevent race conditions from rapid clicks
    if (this.isProcessing) return;
    this.isProcessing = true;

    const currentCount = this.boxItemMealCount;

    if (currentCount >= this.maxItems) {
      alert(`Maximale Anzahl von ${this.maxItems} Produkten erreicht.`);
      this.isProcessing = false;
      return;
    }

    const { mealId } = mealData;
    const existingMeal = this.boxMeals[mealId];

    if (this.boxItemMealCount === 0) {
      this._hideEmptyCartMessage();
    }

    if (existingMeal) {
      this.boxMeals[mealId].quantity += 1;
      this._updateMealCartItemCount(mealId, this.boxMeals[mealId].quantity);
    } else {
      this.boxMeals[mealId] = {
        ...mealData,
        quantity: 1
      };
      this._appendMealItem(this.boxMeals[mealId]);
    }

    if (this.boxItemMealCount === this.maxItems) {
      this._showAddToCartButton();
      this._hideMissingItemsMessage();
      this.displayBoxReadyPopup();
    } else {
      this._hideAddToCartButton();
      this._showMissingItemsMessage();
    }

    if (this.boxItemMealCount >= 6) {
      $('.meal-card.meal_maxqty_6').addClass('disabled');
    }
    if (this.boxItemMealCount >= 12) {
      $('.meal-card.meal_maxqty_12').addClass('disabled');
    }

    this._updateMealListItemCount(mealId, this.boxMeals[mealId].quantity);
    this._updateMissingItemsCount();
    this._updateAddButtonStates();

    localStorage.setItem(`${this.boxHandle}-meals`, JSON.stringify(this.boxMeals));

    // Track meal addition with anomaly detection
    const isOverLimit = this.boxItemMealCount > this.maxItems;
    trackBoxEvent('meal_added', {
      meal_id: mealData.mealId,
      meal_title: mealData.title,
      quantity_after: this.boxMeals[mealId].quantity,
      total_meals: this.boxItemMealCount,
      box_type: this.boxHandle,
      max_items: this.maxItems,
      is_over_limit: isOverLimit,
      unique_meals_in_box: Object.keys(this.boxMeals).length
    });

    // Anomalie explizit tracken wenn limit ueberschritten
    if (isOverLimit) {
      trackBoxEvent('box_limit_exceeded_anomaly', {
        box_type: this.boxHandle,
        max_items: this.maxItems,
        actual_count: this.boxItemMealCount,
        action: 'meal_added',
        meal_id: mealData.mealId,
        meal_title: mealData.title
      });
    }

    this.isProcessing = false;
  }

  removeMealFromBox(meal) {
    // Prevent race conditions from rapid clicks
    if (this.isProcessing) return;
    this.isProcessing = true;

    const { mealId } = meal;

    if (!this.boxMeals[mealId]) {
      this.isProcessing = false;
      return;
    }

    // Store values before removal for tracking
    const quantityBefore = this.boxMeals[mealId].quantity;
    const mealTitle = this.boxMeals[mealId].title;

    if (this.boxMeals[mealId].quantity === 1) {
      delete this.boxMeals[mealId];
      this._removeMealCartItem(mealId);
      this._updateMealListItemCount(mealId, 0);
    } else {
      this.boxMeals[mealId].quantity -= 1;
      this._updateMealCartItemCount(mealId, this.boxMeals[mealId].quantity);
      this._updateMealListItemCount(mealId, this.boxMeals[mealId].quantity);
    }

    if (this.boxItemMealCount === 0) {
      this._showEmptyCartMessage();
      this._hideAddToCartButton();
      this._showMissingItemsMessage();
    } else if (this.boxItemMealCount < this.maxItems) {
      this._hideAddToCartButton();
      this._showMissingItemsMessage();
    }

    if (this.boxItemMealCount < 6) {
      $('.meal-card.meal_maxqty_6').removeClass('disabled');
    }
    if (this.boxItemMealCount < 12) {
      $('.meal-card.meal_maxqty_12').removeClass('disabled');
    }

    this._updateMissingItemsCount();
    this._updateAddButtonStates();
    localStorage.setItem(`${this.boxHandle}-meals`, JSON.stringify(this.boxMeals));

    // Track meal removal
    trackBoxEvent('meal_removed', {
      meal_id: mealId,
      meal_title: mealTitle,
      quantity_before: quantityBefore,
      quantity_after: this.boxMeals[mealId]?.quantity || 0,
      total_meals_remaining: this.boxItemMealCount,
      box_type: this.boxHandle,
      max_items: this.maxItems,
      unique_meals_in_box: Object.keys(this.boxMeals).length
    });

    this.isProcessing = false;
  }

  clearSidecart() {
    this.boxMeals = {};
    this._showMissingItemsMessage();
    this._hideAddToCartButton();
    this._showEmptyCartMessage();
    this._updateMissingItemsCount();
    this._updateAddButtonStates(); // Re-enable buttons after clearing
    $('.meal-list-item__quantity').text(0);
    this.boxMealsContainerEl.html('');
  }

  displayBoxReadyPopup() {
    if (this.boxItemMealCount !== this.maxItems) {
      alert(`Bitte wählen Sie genau ${this.maxItems} Produkte aus. Aktuelle Anzahl: ${this.boxItemMealCount}.`);
      return;
    }

    // Track box completed
    trackBoxEvent('box_completed', {
      box_type: this.boxHandle,
      max_items: this.maxItems,
      total_meals: this.boxItemMealCount,
      unique_meals_count: Object.keys(this.boxMeals).length,
      meal_breakdown: Object.values(this.boxMeals).map(m => ({
        id: m.mealId,
        title: m.title,
        qty: m.quantity
      }))
    });

    const modalContent = `
      <section class="build-a-box-popup">
        <span class="build-a-box-popup__close-btn">X</span>
        <div class="build-a-box-popup__content">
          <h1>Deine Box ist fertig!</h1>
          <div class="build-a-box-popup__box-contents">
            <ul class="build-a-box-popup__box-contents-list">
              ${Object.keys(this.boxMeals).map(key => `
                <li>
                  <img src="${this.boxMeals[key].imageUrl}" alt="${this.boxMeals[key].title}">
                  <p>
                    <span>${this.boxMeals[key].quantity}X</span> ${this.boxMeals[key].title}
                  </p>
                </li>
              `).join('')}
            </ul>
          </div>
          <div class="build-a-box-popup__actions">
            <button class="build-a-box-popup__add-to-cart">In den Warenkorb</button>
          </div>
        </div>
      </section>
    `;

    const popupContainer = document.querySelector('.build-a-box-popup__container');
    popupContainer.innerHTML = modalContent;
    popupContainer.classList.add('active');

    $('html').addClass('disabled-scroll');

    const that = this;

    $(document).on('click', '.build-a-box-popup__close-btn', function () {
      that.closeBoxReadyPopup();
      $('html').removeClass('disabled-scroll');
    });

    $(document).on('click', '.build-a-box-popup__add-to-cart', function () {
      const $btn = $(this);
      $btn.prop('disabled', true).text('Wird hinzugefügt...');
      that.handleBuildABoxPopupAddToCart().catch(() => {
        $btn.prop('disabled', false).text('In den Warenkorb');
      });
    });
  }

  async handleBuildABoxPopupAddToCart() {
    if (this.boxItemMealCount !== this.maxItems) {
      alert(`Bitte wählen Sie genau ${this.maxItems} Produkte aus. Aktuelle Anzahl: ${this.boxItemMealCount}.`);
      this.closeBoxReadyPopup();
      return;
    }

    await this.addToCart();
    this.closeBoxReadyPopup();
    $('html').removeClass('disabled-scroll');
  }

  closeBoxReadyPopup() {
    const popupContainer = document.querySelector('.build-a-box-popup__container');
    popupContainer.classList.remove('active');
    popupContainer.innerHTML = '';
  }

  addBoxToLocalStorage(box) {
    if (!localStorage) return;

    const savedBoxItems = JSON.parse(localStorage.getItem('boxItemsInCart')) || [];

    console.log('[DEBUG addBoxToLocalStorage] Current localStorage boxItemsInCart:', JSON.stringify(savedBoxItems.map(b => ({ id: b.id, key: b.key, handle: b.handle }))));
    console.log('[DEBUG addBoxToLocalStorage] Adding box: id=' + box.id + ', key="' + box.key + '", handle="' + box.handle + '"');

    // Duplicate prevention by unique key (nicht handle, da mehrere Boxen gleichen Typs erlaubt sind)
    const existingByKey = savedBoxItems.find(item => item.key && item.key === box.key);
    if (existingByKey) {
      console.error('[DEBUG addBoxToLocalStorage] BLOCKED: Duplicate key "' + box.key + '" already exists');
      trackBoxEvent('box_localStorage_duplicate_prevented', {
        box_handle: box.handle,
        box_key: box.key
      });
      return;
    }

    const newEntry = {
      ...box,
      boxInstanceId: box.boxInstanceId,
      key: box.key,
      image: box.image,
      title: box.title,
      handle: box.handle,
      quantity: 1
    };

    savedBoxItems.push(newEntry);
    localStorage.setItem('boxItemsInCart', JSON.stringify(savedBoxItems));

    console.log('[DEBUG addBoxToLocalStorage] SAVED. New localStorage boxItemsInCart:', JSON.stringify(savedBoxItems.map(b => ({ id: b.id, key: b.key, handle: b.handle }))));
  }

  _showLoader() {
    this.loaderEl.show();
  }

  _hideLoader() {
    this.loaderEl.hide();
  }

  _showAddToCartButton() {
    // Desktop button
    this.addToCartEl.show();
    // Mobile button
    this.addToCartMobileEl.show();
    // Mobile: Zeige Cart Row (mit flex für korrektes Layout), verstecke Progress Row
    $('.mobile-actions__cart-row').css('display', 'flex');
    $('.mobile-actions__progress-row').hide();
  }

  _hideAddToCartButton() {
    // Desktop button
    this.addToCartEl.hide();
    // Mobile button
    this.addToCartMobileEl.hide();
    // Mobile: Verstecke Cart Row, zeige Progress Row
    $('.mobile-actions__cart-row').hide();
    $('.mobile-actions__progress-row').css('display', 'flex');
  }

  _showEmptyCartMessage() {
    this.emptyCartMessageEl.show();
  }

  _hideEmptyCartMessage() {
    this.emptyCartMessageEl.hide();
  }

  _showMissingItemsMessage() {
    this.missingItemsEl.show();
    this.missingItemsMobileEl.show();
  }

  _hideMissingItemsMessage() {
    this.missingItemsEl.hide();
    this.missingItemsMobileEl.hide();
  }

  _removeMealCartItem(mealId) {
    $(`.build-a-box-sidebar__item[data-meal-id="${mealId}"]`).remove();
  }

  _updateMealListItemCount(mealId, quantity) {
    $(`.meal-list-item[data-meal-id="${mealId}"]`).find('.meal-list-item__quantity').text(quantity);
  }

  _updateMealCartItemCount(mealId, quantity) {
    $(`.build-a-box-sidebar__item[data-meal-id="${mealId}"]`)
      .find('.build-a-box-sidebar__item-quantity span')
      .text(quantity);
  }

  _appendMealItem(meal) {
    const { title, mealId, imageUrl } = meal;

    const mealAttributes = `data-title="${title}" data-meal-id="${mealId}" data-image-url="${imageUrl}"`;

    const mealItemHtml = `
      <div class="build-a-box-sidebar__item" data-meal-id="${mealId}">
        <img src="${imageUrl}" alt="${title}" />
        <p>${title}</p>
        <div class="build-a-box-sidebar__item-quantity">
          <button class="build-a-box-sidebar__decrease-quantity-button" ${mealAttributes}>
            -
          </button>
          <span>${this.boxMeals[mealId].quantity}</span>
          <button class="build-a-box-sidebar__increase-quantity-button" ${mealAttributes}>
            +
          </button>
        </div>
      </div>
    `;

    this.boxMealsContainerEl.append(mealItemHtml);

    const that = this;

    $(document).on('click', `.build-a-box-sidebar__increase-quantity-button[data-meal-id="${mealId}"]`, function () {
      const mealData = $(this).data();
      that.addMealToBox(mealData);
    });

    $(document).on('click', `.build-a-box-sidebar__decrease-quantity-button[data-meal-id="${mealId}"]`, function () {
      const mealData = $(this).data();
      that.removeMealFromBox(mealData);
    });
  }

  _updateMissingItemsCount() {
    const text = this._generateMissingItemsText(this.maxItems - this.boxItemMealCount);
    this.missingItemsEl.html(text);
    this.missingItemsMobileEl.html(text);

    // Update mobile progress bar
    this._updateMobileProgressBar();
  }

  _updateMobileProgressBar() {
    const count = this.boxItemMealCount;
    const percentage = (count / this.maxItems) * 100;

    // Re-query elements to ensure they exist (in case DOM wasn't ready at constructor)
    const $fill = $('.mobile-progress-bar__fill');
    const $count = $('.mobile-progress-bar__count');

    // Update progress bar fill width
    $fill.css('width', percentage + '%');

    // Update count text
    $count.text(count);

    // Row-Sichtbarkeit wird von _showAddToCartButton() / _hideAddToCartButton() gesteuert
    // um sicherzustellen dass Button und Row immer synchron sind
  }

  _updateAddButtonStates() {
    const $addButtons = $('.meal-list-item__increase-quantity-button, .build-a-box-sidebar__increase-quantity-button');
    if (this.boxItemMealCount >= this.maxItems) {
      $addButtons.prop('disabled', true).addClass('disabled');
    } else {
      $addButtons.prop('disabled', false).removeClass('disabled');
    }
  }

  _generateMissingItemsText(missingItemCount) {
    if (missingItemCount > 1) {
      return `Es fehlen noch <span class="missing-item-count">${missingItemCount}</span> Produkte`;
    } else if (missingItemCount === 1) {
      return 'Es fehlt noch <span class="missing-item-count">1</span> Produkt';
    } else {
      return 'Es fehlt noch <span class="missing-item-count">0</span> Produkt';
    }
  }

  _setBoxPrice(price) {
    this.boxPrice = `${(price / 100).toFixed(2)}€ inkl. Mwst`;
    this.headerPriceEl.text(this.boxPrice);
  }

  _addItemsToShopifyCart(items) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify(items),
        dataType: 'json',
        contentType: 'application/json',
        success: function (res) {
          resolve(res.items);
        },
        error: function (error) {
          reject(error);
        }
      });
    });
  }

  _fetchBoxData(boxHandle) {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'GET',
        url: `/products/${boxHandle}.js`,
        success: function (data) {
          resolve(JSON.parse(data));
        },
        error: function (error) {
          reject(error);
        }
      });
    });
  }

  // === CROSS-TAB LOCK METHODS ===

  _acquireCartLock() {
    const lockKey = 'boxCartLock';
    const now = Date.now();
    const LOCK_TIMEOUT_MS = 30000; // 30s Timeout fuer abgestuerzte Tabs

    try {
      const existing = JSON.parse(localStorage.getItem(lockKey));
      if (existing && existing.tabId !== this.tabId && (now - existing.timestamp) < LOCK_TIMEOUT_MS) {
        return false; // Anderer Tab haelt den Lock
      }
    } catch (e) { /* Korrupter Lock, ueberschreiben */ }

    // Lock schreiben
    localStorage.setItem(lockKey, JSON.stringify({ tabId: this.tabId, timestamp: now }));

    // Verify nach Write (gegen simultane Writes von zwei Tabs)
    try {
      const verification = JSON.parse(localStorage.getItem(lockKey));
      return verification && verification.tabId === this.tabId;
    } catch (e) {
      return false;
    }
  }

  _releaseCartLock() {
    try {
      const existing = JSON.parse(localStorage.getItem('boxCartLock'));
      if (existing && existing.tabId === this.tabId) {
        localStorage.removeItem('boxCartLock');
      }
    } catch (e) {
      localStorage.removeItem('boxCartLock'); // Force cleanup bei Korruption
    }
  }

  // === POST-ADD CART VERIFICATION ===

  async _verifyCartAfterAdd() {
    try {
      const cart = await this._fetchShopifyCart();
      const mealItems = cart.items.filter(i => i.product_type === 'meal');
      const boxItems = cart.items.filter(i => i.product_type === 'box' || i.product_type === 'build-a-box');

      const totalMeals = mealItems.reduce((sum, i) => sum + i.quantity, 0);
      const totalExpected = boxItems.reduce((sum, box) => {
        let perBox = 0;
        if (box.handle.includes('18er')) perBox = 18;
        else if (box.handle.includes('12er')) perBox = 12;
        else if (box.handle.includes('6er')) perBox = 6;
        return sum + (perBox * box.quantity);
      }, 0);

      if (totalMeals > totalExpected && totalExpected > 0) {
        trackBoxEvent('cart_integrity_violation_detected', {
          total_meals_in_cart: totalMeals,
          total_expected_meals: totalExpected,
          box_breakdown: boxItems.map(b => ({ handle: b.handle, qty: b.quantity })),
          meal_breakdown: mealItems.map(m => ({ id: m.id, handle: m.handle, qty: m.quantity }))
        });

        // Auto-Korrektur: ueberschuessige Meals entfernen
        await this._correctCartOverflow(cart, totalExpected, boxItems);
      }

      return { valid: totalMeals <= totalExpected, totalMeals, totalExpected };
    } catch (error) {
      console.error('Cart verification error:', error);
      trackBoxEvent('cart_verification_error', { error: error.message || 'Unknown' });
      return { valid: true }; // Bei Fehler nicht blockieren, Checkout-Gate faengt es
    }
  }

  async _correctCartOverflow(cart, totalExpected, boxItems) {
    try {
      // Berechne erwartete Meals pro Box basierend auf boxItemsInCart localStorage
      const boxItemsLS = JSON.parse(localStorage.getItem('boxItemsInCart')) || [];
      const expectedMealQuantities = {};

      boxItemsLS.forEach(box => {
        if (box.boxItems) {
          box.boxItems.forEach(meal => {
            const mealId = String(meal.mealId);
            expectedMealQuantities[mealId] = (expectedMealQuantities[mealId] || 0) + (meal.quantity * (box.quantity || 1));
          });
        }
      });

      // Baue Updates: setze Meal-Mengen auf erwartete Werte
      const updates = {};
      cart.items.forEach(item => {
        if (item.product_type === 'meal') {
          const expected = expectedMealQuantities[String(item.id)] || 0;
          if (item.quantity > expected) {
            updates[item.key] = expected; // Auf erwartete Menge setzen (0 = entfernen)
          }
        }
      });

      if (Object.keys(updates).length > 0) {
        await new Promise((resolve, reject) => {
          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: JSON.stringify({ updates }),
            dataType: 'json',
            contentType: 'application/json',
            success: resolve,
            error: reject
          });
        });

        trackBoxEvent('cart_integrity_violation_corrected', {
          corrections: updates,
          total_expected: totalExpected
        });
      }
    } catch (error) {
      console.error('Cart overflow correction error:', error);
      trackBoxEvent('cart_correction_error', { error: error.message || 'Unknown' });
    }
  }

  _fetchShopifyCart() {
    return new Promise((resolve, reject) => {
      $.getJSON('/cart.js', (data) => {
        resolve(typeof data === 'string' ? JSON.parse(data) : data);
      }).fail(reject);
    });
  }

  get boxItemMealCount() {
    return Object.keys(this.boxMeals).reduce((acc, mealKey) => {
      acc += this.boxMeals[mealKey].quantity;
      return acc;
    }, 0);
  }
}